import { FormControl } from '@angular/forms';
import { DateUtils, isNullOrEmpty } from '@awp/core/utils';
import { isInRange } from './number.validator';


function isValidateMonth(value: number | string | null): boolean {
  return isInRange(value, 1, 12);
}

function isValidYear(value: number | string): boolean {
  const year = Number(value) + DateUtils.currentCentury();
  const thisYear = new Date().getFullYear();

  if (year >= thisYear && year <= thisYear + 10) {
    return true;
  }

  return false;
}

function isValidMonthAndYear(month: number | string, year: number | string): boolean {
  const fullYear = Number(year) + DateUtils.currentCentury();
  const expiryTotalMonths = fullYear * 12 + Number(month);
  const today = new Date();
  const currentTotalMonths = today.getFullYear() * 12 + today.getMonth() + 1;

  return expiryTotalMonths >= currentTotalMonths;
}

export class ExpiryValidator {

  static isValid(control: FormControl) {
    if (control.value == null) {
      return null;
    }

    const { month, year } = control.value;

    if (isNullOrEmpty(month) && isNullOrEmpty(year)) {
      return {
        required: true
      };
    }

    if (!isNullOrEmpty(month)) {
      if (!isValidateMonth(month)) {
        return {
          monthInvalid: true
        };
      }
    } else {
      return {
        monthRequired: true
      };
    }

    if (!isNullOrEmpty(year)) {
      if (!isValidYear(year)) {
        return {
          yearInvalid: true
        }
      }
    } else {
      return {
        yearRequired: true
      };
    }

    if (!isValidMonthAndYear(month, year)) {
      return {
        dateInvalid: true
      };
    }

    return null;
  }

}
